import React from 'react';
export function WhatYouGet() {
  return <section className="w-full bg-[#0a0a0a] py-16 px-4 pt-[10px] pb-[10px]" data-id="element-309">
      <div className="max-w-5xl mx-auto" data-id="element-310">
        <h2 className="text-3xl sm:text-4xl font-black text-white text-center mb-12" data-id="element-311">
          Lo que <span className="text-[#FFD700]" data-id="element-312">recibís</span>
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12" data-id="element-313">
          {/* Primaria */}
          <div className="bg-black border border-[#FFD700]/30 rounded-2xl p-6" data-id="element-314">
            <h3 className="text-[#FFD700] text-xl font-black mb-2" data-id="element-315">
              📘 PRIMARIA — 6 Tomos
            </h3>
            <p className="text-gray-400 text-sm mb-5" data-id="element-316">
              Para docentes de Música de 1° a 6° grado
            </p>
            <div className="space-y-3" data-id="element-317">
              <div className="flex items-center gap-3 text-white" data-id="element-318">
                <span className="text-xl" data-id="element-319">📘</span>
                <div data-id="element-320">
                  <span className="font-bold" data-id="element-321">Tomo 1 — 1° Grado:</span>
                  <span className="text-gray-300" data-id="element-322"> Exploradores Sonoros</span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-323">
                <span className="text-xl" data-id="element-324">📗</span>
                <div data-id="element-325">
                  <span className="font-bold" data-id="element-326">Tomo 2 — 2° Grado:</span>
                  <span className="text-gray-300" data-id="element-327"> Ritmo y Movimiento</span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-328">
                <span className="text-xl" data-id="element-329">📙</span>
                <div data-id="element-330">
                  <span className="font-bold" data-id="element-331">Tomo 3 — 3° Grado:</span>
                  <span className="text-gray-300" data-id="element-332"> Historias con Sonidos</span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-333">
                <span className="text-xl" data-id="element-334">📕</span>
                <div data-id="element-335">
                  <span className="font-bold" data-id="element-336">Tomo 4 — 4° Grado:</span>
                  <span className="text-gray-300" data-id="element-337">
                    {' '}
                    Nuestra Identidad Sonora
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-338">
                <span className="text-xl" data-id="element-339">📓</span>
                <div data-id="element-340">
                  <span className="font-bold" data-id="element-341">Tomo 5 — 5° Grado:</span>
                  <span className="text-gray-300" data-id="element-342"> Arquitectos Musicales</span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-343">
                <span className="text-xl" data-id="element-344">📔</span>
                <div data-id="element-345">
                  <span className="font-bold" data-id="element-346">Tomo 6 — 6° Grado:</span>
                  <span className="text-gray-300" data-id="element-347"> Música y Tecnología</span>
                </div>
              </div>
            </div>
          </div>

          {/* Secundaria */}
          <div className="bg-black border border-[#FFD700]/30 rounded-2xl p-6" data-id="element-348">
            <h3 className="text-[#FFD700] text-xl font-black mb-2" data-id="element-349">
              📗 SECUNDARIA — 6 Tomos
            </h3>
            <p className="text-gray-400 text-sm mb-5" data-id="element-350">
              Para docentes de Música de 1° a 6° año
            </p>
            <div className="space-y-3" data-id="element-351">
              <div className="flex items-center gap-3 text-white" data-id="element-352">
                <span className="text-xl" data-id="element-353">📘</span>
                <div data-id="element-354">
                  <span className="font-bold" data-id="element-355">Tomo 1 — 1° Año:</span>
                  <span className="text-gray-300" data-id="element-356"> El Fenómeno Sonoro</span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-357">
                <span className="text-xl" data-id="element-358">📗</span>
                <div data-id="element-359">
                  <span className="font-bold" data-id="element-360">Tomo 2 — 2° Año:</span>
                  <span className="text-gray-300" data-id="element-361">
                    {' '}
                    El Lenguaje de la Melodía
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-362">
                <span className="text-xl" data-id="element-363">📙</span>
                <div data-id="element-364">
                  <span className="font-bold" data-id="element-365">Tomo 3 — 3° Año:</span>
                  <span className="text-gray-300" data-id="element-366">
                    {' '}
                    Música, Sociedad y Forma
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-367">
                <span className="text-xl" data-id="element-368">📕</span>
                <div data-id="element-369">
                  <span className="font-bold" data-id="element-370">Tomo 4 — 4° Año:</span>
                  <span className="text-gray-300" data-id="element-371"> Creación y Producción</span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-372">
                <span className="text-xl" data-id="element-373">📓</span>
                <div data-id="element-374">
                  <span className="font-bold" data-id="element-375">Tomo 5 — 5° Año:</span>
                  <span className="text-gray-300" data-id="element-376">
                    {' '}
                    Música, Imagen y Narrativa
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-377">
                <span className="text-xl" data-id="element-378">📔</span>
                <div data-id="element-379">
                  <span className="font-bold" data-id="element-380">Tomo 6 — 6° Año:</span>
                  <span className="text-gray-300" data-id="element-381">
                    {' '}
                    Del Aula al Escenario Global
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* What each tome includes */}
        <div className="bg-[#FFD700]/5 border border-[#FFD700]/30 rounded-2xl p-8 text-center" data-id="element-382">
          <h3 className="text-[#FFD700] text-xl font-black mb-6" data-id="element-383">
            Cada tomo incluye:
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-2xl mx-auto" data-id="element-384">
            <div className="flex items-start gap-2 text-left" data-id="element-385">
              <span className="text-green-400 font-bold flex-shrink-0" data-id="element-386">✅</span>
              <span className="text-white text-sm" data-id="element-387">
                Planificación anual lista para la carpeta docente
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-388">
              <span className="text-green-400 font-bold flex-shrink-0" data-id="element-389">✅</span>
              <span className="text-white text-sm" data-id="element-390">
                Guion de clase completo (inicio–desarrollo–cierre)
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-391">
              <span className="text-green-400 font-bold flex-shrink-0" data-id="element-392">✅</span>
              <span className="text-white text-sm" data-id="element-393">
                Actividades concretas sin instrumentos caros
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-394">
              <span className="text-green-400 font-bold flex-shrink-0" data-id="element-395">✅</span>
              <span className="text-white text-sm" data-id="element-396">
                Rúbricas y evidencias de evaluación incluidas
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-397">
              <span className="text-green-400 font-bold flex-shrink-0" data-id="element-398">✅</span>
              <span className="text-white text-sm" data-id="element-399">
                Proyectos integradores por unidad
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-400">
              <span className="text-green-400 font-bold flex-shrink-0" data-id="element-401">✅</span>
              <span className="text-white text-sm" data-id="element-402">
                Efemérides argentinas integradas por grado y año
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}